import { TripType } from '../interfaces/triptype.interface';

export const CmsTripTypeMap = {
  [TripType.ONEWAY]: 'oneWay',
  [TripType.RETURN]: 'return',
  [TripType.MULTICITY]: 'multiCity',
};
